import React, { useRef } from 'react';
import styled from 'styled-components';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form } from 'react-final-form';

import { ReactComponent as CloseSvg } from '@joinforma/ui/assets/icons/close.svg';
import { BUTTON_TYPES } from '@joinforma/ui/constants/properties';
import Button from '@joinforma/ui/components/Button';
import TextField from '@joinforma/ui/components/TextField';

import { StoreRoutes } from 'utils/routeGenerator';

const SEARCH_PATH = '/search';

const FormContainer = styled.form`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const SearchInput = styled(TextField)`
  background: ${({ theme }) => theme.colors.background.primary};
  width: 521px;
  border-radius: 6px;
`;

const SearchButton = styled(Button).attrs({
  type: BUTTON_TYPES.SUBMIT,
})`
  height: 100%;
`;

const SearchBox = ({
  label,
  query,
  setSearchQuery,
}: {
  label: string;
  query: string;
  setSearchQuery: (query: string) => void;
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const input = useRef<HTMLInputElement | null>(null);

  const renderCloseIcon = () => <CloseSvg aria-label="Clear search" />;

  const search = () => {
    const route = StoreRoutes.search({ query });
    const options = location.pathname === SEARCH_PATH ? { replace: true } : {};
    navigate(route, options);
  };
  const handleClear = () => {
    setSearchQuery('');
    input?.current?.querySelector('input')?.focus();
  };

  return (
    <Form
      onSubmit={search}
      render={({ handleSubmit }) => (
        <FormContainer onSubmit={handleSubmit}>
          <SearchInput
            end_icon={query ? renderCloseIcon : undefined}
            hide_label_on_focus={true}
            label={label}
            ref={input}
            value={query}
            onChange={setSearchQuery}
            onClickEndIcon={handleClear}
          />
          <SearchButton onClick={handleSubmit}>Search</SearchButton>
        </FormContainer>
      )}
    />
  );
};

export default SearchBox;
